<template>
	<div class="profile-wrapper">
		<div class="title" v-if="!data.id">添加您的项目案例</div>
		<div class="title" v-else>案例修改</div>
		<el-row :gutter="30">
		  <el-col :span="12">
			<div class="labelname"><span class="required">*</span>名称</div>
			<div><el-input v-model="data.title" size="medium" placeholder="请输入内容"></el-input></div>  
		  </el-col>
		  <el-col :span="12">
			<div class="labelname"><span class="required">*</span>行业领域</div>
			<div>
				<el-select v-model="data.sex" size="medium" placeholder="请选择行业领域">
				    <el-option
				      v-for="item in industry"
				      :key="item.dictValue"
				      :label="item.dictLabel"
				      :value="item.dictValue">
				    </el-option>
				</el-select>
			</div>   
		  </el-col>
		</el-row>
		<!-- <el-row>
		  <el-col :span="24">
			<div class="labelname"><span class="required">*</span>使用技术（多选）</div>
			<div>
				<el-select v-model="data.tele" multiple placeholder="请选择">
				    <el-option
				      v-for="item in industry"
				      :key="item.dictValue"
				      :label="item.dictLabel"
				      :value="item.dictValue">
				    </el-option>
				  </el-select>
			</div>  
		  </el-col>
		</el-row> -->
		<el-row>
		  <el-col :span="24">
			<div class="labelname"><span class="required">*</span>项目简介</div>
			<div><el-input v-model="data.summary" type="textarea" :rows="5" placeholder="请输入内容"></el-input></div>  
		  </el-col>
		</el-row>
		<el-row>
		  <el-col :span="10">
			<div class="labelname"><span class="required">*</span>封面上传</div>
			<el-upload
			  class="uploader"
			  :action="http"
			  :headers="headers"
			  :show-file-list="false"
			  :on-success="handleSuccess">
			  <el-image v-if="data.cover" :src="data.cover" class="avatar-cover" fit="fill"></el-image>
			  <i v-else class="iconfont icon-tianjia"></i>
			</el-upload>
		  </el-col>
		</el-row>
		<el-row>
		  <el-col :span="20">
			<div class="labelname"><span class="required">*</span>文件上传</div>
			<div>
				<el-input v-model="data.file" size="medium" placeholder="请输入内容" class="program"></el-input>
				<el-upload style="display: inline-block;"
				  :action="http"
				  :headers="headers"
				  :show-file-list="false"
				  :on-success="handleFile">
				  <el-button type="warning" size="medium" class="upload-btn">点击上传</el-button>
				  <!-- <el-button type="warning" size="medium" class="upload-btn" @click="previewFile">预览</el-button> -->
				</el-upload>
			</div>  
		  </el-col>
		</el-row>
		<el-row>
		  <el-col :span="20">
			<div style="display:inline-block" class="labelname"><span class="required">*</span>是否加密</div>
			<div style="display:inline-block;margin-left: 15px;">
				<el-switch v-model="data.isPrivate" active-color="#13ce66" active-value="1" inactive-value="0"></el-switch>
			</div>  
		  </el-col>
		</el-row>
		<el-button type="warning" size="medium" class="submit" @click="submitHandle">提交作品</el-button>
	</div>
</template>

<script>
import {  getIndustry } from '@/api/anli/anli'
import {  updateUsercase,addUsercase } from '@/api/personal/index'
import { apiBaseURL } from '@/utils/request'
import {  getToken } from '@/utils/auth'
export default {
  data () {
    return {
      industry: [],
	  data: {
		  cover:'',
		  filename:'',
		  filePath:''
	  },
	  http:'',
	  headers:{
		token: ''
	  }
    }
  },
  methods: {
	async getIndustryList(){
		const res = await getIndustry()
		if (res.code === 0) {
			this.industry = res.data[0].dataList
		} else {
		  this.$message.error(res.msg)
		}
	},
	previewFile(){
		window.open(this.data.previewUrl)
	},
	handleSuccess(response, file, fileList) {
		console.log(response, file, fileList)
		this.data.cover = response.data.src
    },
	handleFile(response, file, fileList) {
		console.log(response, file, fileList)
		this.data.filename = file.name
		this.data.filePath = response.data.src
    },
	async submitHandle(){
		const res = await addUsercase(this.data)
		if (res.code === 0) {
			this.$message.success('上传成功')
		} else {
		  this.$message.error(res.msg)
		}
	},
	async updateHandle(){
		const res = await updateUsercase(this.data)
		if (res.code === 0) {
			this.$message.success('修改成功')
		} else {
		  this.$message.error(res.msg)
		}
	}
  },
  mounted () {
	this.getIndustryList()  
	this.http = apiBaseURL+'/sys/oss/upload'
	this.headers.token = getToken()
	this.data.id = this.$route.params.id
	this.data = JSON.parse(this.$route.params.data)
  }

}
</script>

<style lang="scss" scoped>
.profile-wrapper{
	padding: 30px 40px;
	.title{
		font-size: 20px;
		font-weight: 800;
		text-align: center;
	}

	.el-row{
		margin-top: 20px;
		&:last-child{
			margin-top: 50px;
		}
		.labelname{
			color: #505050;
			font-size: 14px;
			margin: 5px 0;
		}
		.el-col{
			position: relative;
			.el-select{
				width: 100%;
			}
			.required{
				color: #F50000;
			}
			.program{
				width: 300px;
			}
			.upload-btn{
				background-color: #FF842E;
				border-radius: 5px;
				margin-left: 10px;
			}
			.uploader{
				width: 150px;
				height: 150px;
				border-radius: 8px;
				border: 1px solid #E8E8E9;
				margin-top: 10px;
				display: flex;
				justify-content: center;
				align-items: center;
				.iconfont{
					color: #DFDFDF;
					font-size: 32px;
				}
			}
			.avatar-cover{
				width: 150px;
				height: 150px;
			}
		}
		.image-tip{
			font-size: 14px;
			color: #AAA9A9;
			position: absolute;
			text-align: center;
			bottom: 20px;
			left: 50%;
			margin-left: -40px;
		}
		/deep/.el-input.is-active .el-input__inner, 
		/deep/.el-input__inner:focus,
		/deep/.el-textarea__inner:focus{
			border-color: #C0C4CC;
		}
		/deep/.el-range-editor.is-active, 
		/deep/.el-range-editor.is-active:hover, 
		/deep/.el-select .el-input.is-focus .el-input__inner{
			border-color: #C0C4CC;
		}
	}
	.submit{
		background-color: #FF842E;
		border-radius: 5px;
		width: 120px;
		margin: 50px auto;
	}
}	
/* 针对平板的样式 */
@media (min-width: 768px) and (max-width: 1024px) {
	.tips{
		
		margin: 5px 0 !important;
		
	}
}
</style>